import Loader from "./loader"

const FullScreenLoader = () => {
    return (
        <div className="fixed top-0 left-0 z-50 flex h-screen w-full items-center justify-center bg-primary bg-opacity-10 backdrop-blur-lg">
            <Loader />
        </div>
    )
}

export default FullScreenLoader
